export function Software() {
    return (
        <span>
            Software
        </span>
    )
}